import React, { useState, useEffect } from 'react';
import {
  Box,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Chip,
  Typography
} from '@mui/material';

const FiltrosPeriodo = ({ onFiltroChange, filtrosActivos = {} }) => {
  const [años, setAños] = useState(['2024', '2025']); // valor por defecto
  
  // Cargar años disponibles desde la API
  useEffect(() => {
    const cargarAños = async () => {
      try {
        const response = await fetch('/api/anos');
        if (response.ok) {
          const data = await response.json();
          console.log('📅 Años disponibles:', data);
          setAños(data.map(item => item.año.toString()).sort((a, b) => b - a));
        }
      } catch (error) {
        console.error('Error cargando años:', error);
        // Mantener años por defecto si hay error
      }
    };
    
    cargarAños();
  }, []);

  // Meses independientes de años
  const meses = [
    'Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio',
    'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'
  ];
  const ordenOpciones = [
    { value: 'monto', label: 'Por Monto' },
    { value: 'nombre', label: 'Por Nombre' },
    { value: 'fecha', label: 'Por Fecha' }
  ];

  const handleChange = (campo, valor) => {
    const nuevosFiltros = {
      ...filtrosActivos,
      [campo]: valor === '' ? undefined : valor
    };
    onFiltroChange(nuevosFiltros);
  };

  const limpiarFiltro = (campo) => {
    const nuevosFiltros = { ...filtrosActivos };
    delete nuevosFiltros[campo];
    onFiltroChange(nuevosFiltros);
  };

  return (
    <Box sx={{ display: 'flex', gap: 2, mb: 2, flexWrap: 'wrap', alignItems: 'center' }}>
      <FormControl size="small" sx={{ minWidth: 120 }}>
        <InputLabel>Mes</InputLabel>
        <Select
          value={filtrosActivos.mes || ''}
          label="Mes"
          onChange={(e) => handleChange('mes', e.target.value)}
        >
          <MenuItem value="">Todos</MenuItem>
          {meses.map(mes => (
            <MenuItem key={mes} value={mes}>{mes}</MenuItem>
          ))}
        </Select>
      </FormControl>

      <FormControl size="small" sx={{ minWidth: 120 }}>
        <InputLabel>Año</InputLabel>
        <Select
          value={filtrosActivos.ano || ''}
          label="Año"
          onChange={(e) => handleChange('ano', e.target.value)}
        >
          <MenuItem value="">Todos</MenuItem>
          {años.map(año => (
            <MenuItem key={año} value={año}>{año}</MenuItem>
          ))}
        </Select>
      </FormControl>

      <FormControl size="small" sx={{ minWidth: 120 }}>
        <InputLabel>Ordenar</InputLabel>
        <Select
          value={filtrosActivos.orden || 'monto'}
          label="Ordenar"
          onChange={(e) => handleChange('orden', e.target.value)}
        >
          {ordenOpciones.map(opcion => (
            <MenuItem key={opcion.value} value={opcion.value}>{opcion.label}</MenuItem>
          ))}
        </Select>
      </FormControl>

      {/* Mostrar filtros activos como chips */}
      <Box sx={{ display: 'flex', gap: 1, flexWrap: 'wrap' }}>
        {filtrosActivos.mes && (
          <Chip
            label={`Mes: ${filtrosActivos.mes}`}
            onDelete={() => limpiarFiltro('mes')}
            size="small"
            color="primary"
          />
        )}
        {filtrosActivos.ano && (
          <Chip
            label={`Año: ${filtrosActivos.ano}`}
            onDelete={() => limpiarFiltro('ano')}
            size="small"
            color="primary"
          />
        )}
        {filtrosActivos.orden && filtrosActivos.orden !== 'monto' && (
          <Chip
            label={`Orden: ${ordenOpciones.find(o => o.value === filtrosActivos.orden)?.label}`}
            onDelete={() => limpiarFiltro('orden')}
            size="small"
            color="primary"
          />
        )}
      </Box>
    </Box>
  );
};

export default FiltrosPeriodo;